/**
 * @module interface
 */
export interface V2TimMergerElem {
    isLayersOverLimit?: boolean;
    title?: string;
    abstractList?: string[];
}
